import { render, staticRenderFns } from "./DeleteReportCustomGroup.vue?vue&type=template&id=9624bab2"
import script from "./DeleteReportCustomGroup.vue?vue&type=script&lang=js"
export * from "./DeleteReportCustomGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports